import { z } from "zod";
import { VictimDTOz, type VictimDTO } from "@shared/contracts";
import { get, qs } from "./client";
import { log } from "console";

export async function fetchVictimsByKiller(
  killerId: string,
  signal?: AbortSignal
): Promise<VictimDTO[]> {
  return get(
    `/victims/getVictimsByKiller${qs({ killerId })}`,
    (raw) => z.array(VictimDTOz).parse(raw),
    { signal }
  );
}

export async function fetchVictims(
  query: {
    status?: string;
    country?: string | null;
    region?: string | null;
    from?: string | null;
    to?: string | null;
  },
  signal?: AbortSignal
): Promise<VictimDTO[]> {
  return get(
    `/victims/getVictims${qs({
      status: query.status,
      country: query.country,
      region: query.region,
      from: query.from,
      to: query.to,
    })}`,
    (raw) => z.array(VictimDTOz).parse(raw),
    { signal }
  );
}